import { z } from "@msuite/utils/lib/zod";
import { defineQuery } from "@rocicorp/zero";
import { zql } from "../zql";

export const organizationQueries = {
	// The one query that may legitimately address a foreign organisation, in both directions of
	// the partner model: the board shows the name of a partner crew's organisation, and a guest
	// board is titled with the name of the organisation whose board it is. Reachable rows are
	// the caller's own organisation, any organisation with a crew on one of the caller's plans,
	// and any organisation whose plan carries one of the caller's crews — nothing enumerable
	// beyond that.
	byId: defineQuery(
		z.object({
			orgId: z.string(),
		}),
		({ args, ctx }) => {
			return zql.organizations
				.where("id", "=", args.orgId)
				.where(({ cmp, exists, or }) =>
					or(
						cmp("id", "=", ctx.orgId),
						exists("crews", (crew) =>
							crew.whereExists("plan", (plan) => plan.where("orgId", "=", ctx.orgId)),
						),
						exists("plans", (plan) =>
							plan.whereExists("crews", (crew) => crew.where("orgId", "=", ctx.orgId)),
						),
					),
				)
				.one();
		},
	),
};
